export enum equipementTypes {
    LOADING = "LOADING",
    SELECTED_EQUIPEMENT = "SELECTED_EQUIPEMENT",
    GET_EQUIPEMENT_LIST = "GET_EQUIPEMENT_LIST",
}
  
export default equipementTypes;